






























































































import { Component, Vue, Prop } from 'vue-property-decorator';
import DynamicDivider from '@/components/DynamicDivider.vue';

@Component({
  components: {
    DynamicDivider,
  },
})
export default class CertificateInformation extends Vue {
  @Prop() public certificatePayload!: any;
  @Prop() public isCertificateView!: boolean;
  @Prop() public isRevoked!: boolean;
  @Prop() public clickedPage!: boolean;
  @Prop() public desktop!: boolean;

  get parsed() {
    const {...parsed} = this.certificatePayload.data;
    return parsed;
  }

  get isShow() {
    return this.clickedPage;
  }
  get isDesktop() {
    return this.desktop;
  }
}
